import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { QuoteDocument, RepQuoteFormState } from 'shared/types/quotes';
import { BasicQuoteForm } from './basic-quote-form';

interface Props {
  quote: QuoteDocument;
}
export function CopyQuote(props: Props) {
  const methods = useForm<RepQuoteFormState>({
    defaultValues: {
      wholesaler: props.quote.wholesaler,
      wholesalerCustomerNumber: props.quote.wholesalerCustomerNumber,
      wholesalerCity: props.quote.wholesalerCity,
      wholesalerState: props.quote.wholesalerState,
      wholesalerContact: props.quote.wholesalerContact,
      wholesalerEmail: props.quote.wholesalerEmail,
      wholesalerPhone: props.quote.wholesalerPhone,
      plumberContractor: props.quote.plumberContractor,
      plumberProjectType: props.quote.plumberProjectType,
      plumberArchitect: props.quote.plumberArchitect,
      plumberEngineer: props.quote.plumberEngineer,
      plumberSpecifiedMfg: props.quote.plumberSpecifiedMfg,
      plumberOutOfTerritory: props.quote.plumberOutOfTerritory,
      jobInfoProjectName: props.quote.jobInfoProjectName,
      jobInfoCity: props.quote.jobInfoCity,
      jobInfoState: props.quote.jobInfoState,
      jobInfoStateName: props.quote.jobInfoStateName,
      jobInfoFullTruckload: props.quote.jobInfoFullTruckload,
      jobInfoEstimatedSchedule: props.quote.jobInfoEstimatedSchedule,
      jobInfoReleaseAndFirstOrderDate: props.quote.jobInfoReleaseAndFirstOrderDate,
      jobInfoJobDuration: props.quote.jobInfoJobDuration,
      competitionInfoSourceOfInfo: props.quote.competitionInfoSourceOfInfo,
      competitionInfoOtherSourceOfInfo: props.quote.competitionInfoOtherSourceOfInfo,
      competitionInfoCompetition: [...props.quote.competitionInfoCompetition],
      products: [...props.quote.products],
      quoteDocumentation: [],
      notes: props.quote.notes,
      optionsETOS: props.quote.optionsETOS,
      requestedBy: props.quote.requestedBy,
      repAgency: props.quote.repAgency,
      director: props.quote.director,
      brand: props.quote.brand,
      quoteFilesToDelete: [],
    },
  });
  const { setValue } = methods;
  useEffect(() => {
    setValue('products', props.quote.products);
    setValue('competitionInfoCompetition', props.quote.competitionInfoCompetition);
  }, [props.quote.products, setValue, props.quote.competitionInfoCompetition]);
  return <BasicQuoteForm methods={methods} quote={props.quote} />;
}
